<template>
  <div class="daily-reward-overlay" v-if="show">
    <div class="daily-reward-content" role="dialog" aria-modal="true" :aria-label="$t('dailyReward.title')">
      <span class="recompensa__dia">{{ $t('dailyReward.day') }} {{ reward.day }}</span>

      <!-- O engradado do cais (D13): a recompensa diária é uma caixa que chegou no porto. -->
      <FishIcon nome="cais-engradado" tamanho="enorme" class="recompensa__caixa" />

      <h3 class="recompensa__titulo">{{ $t('dailyReward.title') }}</h3>

      <p class="recompensa__linha">
        <span class="material-icons recompensa__icone" :class="getRewardIcon(reward.type)"></span>
        <strong class="t-numero">+{{ reward.amount }}</strong>
      </p>
      <p class="recompensa__texto">{{ getRewardDescription() }}</p>
      <p class="recompensa__texto recompensa__ticket" v-if="ticket">
        +1 {{ $t('dailyReward.ticket') }} ({{ $t('dailyReward.total') }}: {{ ticket }})
      </p>

      <FishButton variante="primario" bloco som="recompensa" @click="closeModal">
        {{ $t('dailyReward.buttonText') }}
      </FishButton>
    </div>
  </div>
</template>

<script>
import { FishButton, FishIcon } from '@/shared/ui';

/**
 * A recompensa diária é O ENGRADADO DO CAIS (D13): uma caixa de madeira que chegou no porto, num
 * bilhete de papel. A versão anterior flutuava em loop, pulsava ondas de água infinitas e brilhava
 * ouro por cima de um fundo preto — o D0 veta os três. A lógica não mudou.
 */
export default {
  name: 'DailyReward',
  components: { FishButton, FishIcon },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    reward: {
      type: Object,
      default: () => ({
        type: '',
        amount: 0
      })
    },
    ticket: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getRewardIcon(type) {
      const icons = {
        stamina: 'fa-bolt',
        gold: 'fa-coins',
        bait: 'fa-bug',
        experience: 'fa-star',
        paralleliums: 'fa-gem'
      };
      return icons[type] || 'fa-gift';
    },
    getRewardDescription() {
      if (!this.reward) return '';

      const descriptions = {
        stamina: `${this.reward.amount} ${this.$t('dailyReward.stamina')}`,
        gold: `${this.reward.amount} ${this.$t('dailyReward.gold')}`,
        bait: this.reward.bait ?
          `${this.reward.amount}x ${this.reward.bait.name}` :
          `${this.reward.amount} ${this.$t('dailyReward.bait')}`,
        experience: `${this.reward.amount} ${this.$t('dailyReward.experience')}`,
        paralleliums: `${this.reward.amount} ${this.$t('dailyReward.paralleliums')}`
      };
      return `${this.$t('dailyReward.youWon')} ${descriptions[this.reward.type] || this.$t('dailyReward.reward')}!`;
    },
    closeModal() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.daily-reward-overlay {
  position: fixed;
  inset: 0;
  background: rgba(7, 32, 48, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  padding: var(--e-3);
}

.daily-reward-content {
  position: relative;
  border: var(--moldura-borda) solid transparent;
  border-image: url('/ui/frame-panel.png') var(--moldura-fatia) / var(--moldura-borda) repeat;
  background: var(--papel);
  background-clip: padding-box;
  image-rendering: pixelated;
  color: var(--tinta);
  padding: var(--e-5) var(--e-4) var(--e-3);
  max-width: 360px;
  width: 100%;
  text-align: center;
  box-shadow: 0 6px 0 rgba(0, 0, 0, 0.4);
  /* Entra UMA vez e para (D0): nada de flutuação em loop. */
  animation: subir-surgindo var(--t-medio) var(--curva-entrada) both;
}

.recompensa__dia {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--ouro);
  color: var(--ouro-escuro);
  border: 2px solid var(--ouro-escuro);
  font-family: var(--fonte-display);
  font-size: var(--f-2);
  padding: 2px var(--e-2);
  white-space: nowrap;
}

.recompensa__caixa {
  margin-bottom: var(--e-2);
}

.recompensa__titulo {
  font-family: var(--fonte-display);
  font-size: var(--f-4);
  line-height: var(--lh-curto);
  margin: 0 0 var(--e-2);
}

.recompensa__linha {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--e-2);
  font-family: var(--fonte-display);
  font-size: var(--f-5);
  color: var(--ouro-escuro);
  margin: 0 0 var(--e-1);
}

.recompensa__icone {
  font-size: var(--f-5);
  width: 24px;
  height: 24px;
}

.recompensa__texto {
  font-family: var(--fonte-corpo);
  font-size: var(--f-2);
  line-height: var(--lh-prosa);
  color: var(--tinta-fraca);
  margin: 0 0 var(--e-2);
}

.recompensa__ticket {
  color: var(--latao);
}
</style>
